import { ILocation } from '../../../api/locations/types';
import { IStationConnector, IStation } from '../../../api/station/types';
import { EConnectorIdentifier } from '../../../api/types';
import {
    getConnectorDisplayLabel,
    getEffectiveConnectorIdentifier,
} from '../../../utils/connector-identifier';
import { getLetterByIndex } from '../../../utils/utils';

type ConnectorWithMeta = IStationConnector & {
    station: IStation;
    connectorNumber: string;
    connectorDisplayLabel: string;
};

const mapConnectors = (
    station: IStation,
    connectorIdentifier?: EConnectorIdentifier
): ConnectorWithMeta[] =>
    station.connectors?.map((connector: IStationConnector, connectorIndex, connectorsArray) => {
        const effectiveConnectorIdentifier = getEffectiveConnectorIdentifier(connectorIdentifier);
        const connectorNumber = `${station?.stationPosition ?? ''}${
            connectorsArray.length > 1 ? `${getLetterByIndex(connectorIndex)}` : ''
        }`;

        return {
            ...connector,
            connectorNumber,
            connectorDisplayLabel: getConnectorDisplayLabel({
                connectorNumber,
                shortCode: connector.qrCode?.shortCode,
                connectorIdentifier: effectiveConnectorIdentifier,
            }),
            station,
        };
    }) ?? [];

export const getAllConnectors = ({
    location,
    station,
}: {
    location?: ILocation;
    station?: IStation;
}) => {
    if (station) {
        return mapConnectors(station, station.stationLocation?.connectorIdentifier);
    }

    if (location) {
        return location.stations
            .flatMap(locationStation =>
                mapConnectors(locationStation, location.connectorIdentifier)
            );
    }

    return [];
};
